const StarRating = ({ rating, count }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "nowrap" }}>
    <div style={{ display: "flex", gap: 2, flexShrink: 0 }}>
      {[1, 2, 3, 4, 5].map((s) => (
        <span
          key={s}
          style={{
            fontSize: 16,
            color: s <= Math.round(rating) ? "#f5a623" : "#ddd",
          }}
        >
          ★
        </span>
      ))}
    </div>
    <span style={{ fontSize: 13, color: "#888", whiteSpace: "nowrap" }}>
      ({count} {count === 1 ? "review" : "reviews"})
    </span>
  </div>
);

export default StarRating;
